export default "__VITE_ASSET__uivkDJXR__"